export default "__VITE_ASSET__BCDwTOeE__"